// extracted by mini-css-extract-plugin
export default {"create":"CreateLink_create__+AMku"};